import { apiFetch } from './api';

export interface BetaSlot {
  slot: string; // A / B / C / D / E
  projectId: string;
  pteroUuid?: string;
  configured: boolean;
  /** Adresse publique custom (ex "beta-a.recube.gg:25567") si renseignée en Settings. */
  publicAddress?: string;
  currentDevEnvId?: string;
  currentDevEnvDisplay?: string;
  lastPromotedAt?: string;
  lastPromotedBy?: string;
}

const baseUrl = (pid: string) => `/api/projects/${pid}/beta-slots`;

export const betaSlotService = {
  list: (pid: string) => apiFetch<BetaSlot[]>(baseUrl(pid)),
  promote: (pid: string, slot: string, devEnvId: string) =>
    apiFetch<void>(`${baseUrl(pid)}/${slot}/promote`, {
      method: 'POST',
      json: { devEnvId },
    }),
  /** Vide un slot : arrête le serveur beta, efface ses fichiers, libère l'association. */
  clear: (pid: string, slot: string) =>
    apiFetch<void>(`${baseUrl(pid)}/${slot}/clear`, { method: 'POST' }),
};
